import * as requestFromServer from '../common/cruds'
import {OrderSlices} from './slices'
import {handleNotificationWithToastify} from '../../../app/services/Functional'
import {callTypes, catchError, endCall, startCall} from '../common/slices'
import {ID} from '../../../_metronic/helpers'

const actions = OrderSlices.actions
const API_URL = `${process.env.REACT_APP_API_BASE_URL}orders/`

export const getOrderById = (id: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.order(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't find order"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const createOrder = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL}`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't create order"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const refreshVidStatus = (id: number) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}update-vechain-order-status/${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't find order"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const confirmOrder = (id: number) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}confirm/${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = 'Something went wrong!'
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const getVidsList = (id: number) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}vechain/vids/list/${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.vidsList(response.data.data))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't find order"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const createVechainOrder = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL}vechain/order/create`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't create order"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const updateOrder = (id: string, order: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .patchRequest(`${API_URL}${id}`, order)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't update order"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const TCCAndVechainOrder = (id: ID, order: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL}upload/${id}`, order)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      if (response.data && response.data.order && response.data.order.status === 'Rejected') {
        const rejectedMsg = {
          message: `${response.data.message}`,
          success: false,
        }
        handleNotificationWithToastify(rejectedMsg)
      } else {
        handleNotificationWithToastify(response.data)
      }
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't update order"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const getOrdersDropdown = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}dropdown`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.ordersDropdown({orders: response.data.data?.orders}))
    })
    .catch((error) => {
      error.clientMessage = "Can't get assets list"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const getCategoryType = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}vechain/available/products?page=1&items_per_page=10`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.categoryType(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = 'Something went wrong'
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const getCountryList = () => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}vechain/available/countries?page=1&items_per_page=1000`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      dispatch(actions.countryList(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = 'Something went wrong'
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const manageMappings =
  (mapping: any) => (dispatch: (arg0: {payload: any; type: string}) => void) => {
    dispatch(startCall({callType: callTypes.action}))
    return requestFromServer
      .postRequest(`${process.env.REACT_APP_API_BASE_URL}mappings`, mapping)
      .then((response) => {
        dispatch(endCall({callType: callTypes.action}))
        handleNotificationWithToastify(response.data)
        return response.data
      })
      .catch((error) => {
        error.clientMessage = "Can't create mapping"
        dispatch(catchError({error, callType: callTypes.action}))
        return error
      })
  }

export const handleIsOrderAPICalledByID = (value: boolean) => (dispatch: any) => {
  dispatch(actions.setIsOrderAPICalledByID(value))
}
